var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmIcon = function SvgConfirmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.997 14.595 5.84 11.438a.3.3 0 0 0-.424 0l-.99.99a.3.3 0 0 0 0 .424l4.368 4.35a.3.3 0 0 0 .425 0l9.35-9.35a.3.3 0 0 0 0-.424l-.99-.99a.3.3 0 0 0-.425 0z"
  })));
};
export default SvgConfirmIcon;